<template>
  <div class="nav-area">

    <div class="top">

      <div class="top-title py-4 text-left" style="padding-left: 15px; padding-right: 15px;">
        <h6 class="font-weight-bold"><img src="/static/img/uko-logo.png" style="height: 3rem; margin-left:15px;"/> 최상의 복합운송 서비스를 제공하여 드립니다.</h6>

      </div>

      <!-- login box -->
      <div class="login-container hide" style="display: none;">
        <div class="container">
          <div class="row">
            <!--
            <a href="login.php" class="hide">
              <div class="col-12">로그인</div>
            </a>
            -->
            <router-link class="hide" :to="'/login'">
              <div class="col-12">로그인</div>
            </router-link>
          </div>
        </div>
      </div><!-- ./login box -->

    </div>

    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <!-- <a class="navbar-brand" href="#">Navbar</a> -->
      <button class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto pa-0">
          <li class="nav-item active">
            <!--
            <a class="nav-link" href="index.php">
              Home<span class="sr-only">(current)</span>
            </a>
            -->
            <router-link class="nav-link" v-on:click.native="navTriggered" exact :to="'/'">
              Home<span class="sr-only">(current)</span>
            </router-link>
          </li>

          <li class="nav-item">
            <!-- <a class="nav-link" href="index.php">About</a> -->
            <router-link class="nav-link" v-on:click.native="navTriggered" exact :to="'/about-us'">회사소개</router-link>

          </li>

          <li class="nav-item">
            <router-link class="nav-link" v-on:click.native="navTriggered" exact :to="'/express'">국제특송</router-link>

          </li>
<!--          <li class="nav-item">-->
<!--            <router-link class="nav-link" v-on:click.native="navTriggered" exact :to="'/'">전자상거래</router-link>-->

<!--          </li>-->
          <li class="nav-item">
            <!-- <a class="nav-link" href="index.php">About</a> -->
            <router-link class="nav-link" v-on:click.native="navTriggered" exact :to="'/agent'">구매/배송대행</router-link>

          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="index.php">About</a> -->
            <router-link class="nav-link" v-on:click.native="navTriggered" exact :to="'/furniture'">안틱가구 운송</router-link>

          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="index.php">About</a> -->
            <router-link class="nav-link" v-on:click.native="navTriggered" exact :to="'/commercial'">상업화물 운송</router-link>

          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="index.php">About</a> -->
            <router-link class="nav-link" v-on:click.native="navTriggered" exact :to="'/art'">전시품 운송</router-link>

          </li>
        </ul>

      </div>
    </nav>

<!--    <v-dialog/>-->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <v-card v-if="dialogParams">
        <v-card-title class="headline">{{dialogParams.title}}</v-card-title>
        <v-card-text v-html="dialogParams.text"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import {mapState, mapGetters} from 'vuex';

import EventBus from '../api/event-bus.js';
export default {
  name: 'TopHeader',
  data() {
    return {
      dialog: false,
      dialogParams: null,
    }
  },
  computed: {

  },
  created() {
    EventBus.$on('showDialog', this.showDialog);
  },
  mounted() {
  },
  methods: {
    navTriggered: function() {
      let nav = document.getElementById("navbarSupportedContent");
      if(nav != null) {
        nav.classList.remove("show");
      }
    },
    showDialog: function(params) {
      console.log("show dialog");
      console.log(params);
      this.dialog = true
      this.dialogParams = params
    },
  }
};
</script>

<style>
.top {
  /*background: url('../assets/img/top-1.jpg') no-repeat center;*/
  background: white;
}
  .router-link-active {
    background: white;
    font-weight: bold;
    color: black;
    /*color: white;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/TopHeader.vue